
import { EmptyState } from '@backstage/core-components';
import Button from '@material-ui/core/Button';

export function OkrEmptyState() {
  return (
    <EmptyState
      title="No OKRs published yet"
      missing="data"
      description="No OKR entities were found in the catalog for this quarter. To add OKRs, commit YAML files following the schema in okrs/schema.md to the global-entities repository."
      action={
        <Button
          variant="outlined"
          color="primary"
          href="https://github.com/arrive-together/global-entities/tree/main/okrs"
          target="_blank"
          rel="noopener noreferrer"
        >
          View OKR schema
        </Button>
      }
    />
  );
}
